import { render, staticRenderFns } from "./Passport.vue?vue&type=template&id=6cced882&scoped=true&"
import script from "./Passport.vue?vue&type=script&lang=js&"
export * from "./Passport.vue?vue&type=script&lang=js&"
import style0 from "./Passport.vue?vue&type=style&index=0&id=6cced882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cced882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cced882')) {
      api.createRecord('6cced882', component.options)
    } else {
      api.reload('6cced882', component.options)
    }
    module.hot.accept("./Passport.vue?vue&type=template&id=6cced882&scoped=true&", function () {
      api.rerender('6cced882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Passport.vue"
export default component.exports